import { stepName } from './model.ts';

/**
 * Find a step (the tools at the top of a tree, Tools.tsx): what it lists, and how a name typed matches. One rule for the
 * master tree, a job set up (every step of the tree, Jason, 2026-10-08, L-18 C) and a job run.
 */

/** A step Find lists. */
export interface FindStep {
  /** Its key in the drawing: what choosing it rings (drawn where it would go, where it is not drawn otherwise). */
  key: string;
  title: string;
  /** Where it stands, in words: "Construction · not on this job". */
  where?: string;
  /** What can be done with it from the list: "+ Add", "Put it back". Without it, the list offers Show it. */
  act?: { word: string; run: () => void };
}

/**
 * The steps a name typed matches, by their names as drawn (Title Case): every one whose name holds what was typed,
 * whatever its case, those it starts with first, each kept in the order given otherwise. Nothing typed, nothing found.
 */
export function findMatches<T extends Pick<FindStep, 'title'>>(steps: readonly T[], text: string): T[] {
  const q = text.trim().toLowerCase();
  if (!q) return [];
  const named = steps.map((s) => ({ s, name: stepName(s.title).toLowerCase() })).filter((x) => x.name.includes(q));
  return [...named.filter((x) => x.name.startsWith(q)), ...named.filter((x) => !x.name.startsWith(q))].map((x) => x.s);
}
